import React, { useEffect, useMemo } from "react";
import { Fragment } from "react";
import {
    Alert,
    Badge,
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    InputGroup,
    InputGroupText,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Spinner,
    Table,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import {
    GetCookieData,
    GetCookieToken,
    GetUserInfo,
} from "../Cookie/GetCookie";
import axios from "axios";
import { useState } from "react";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import dayjs from "dayjs";
import EvaluateForm from "./EvaluateForm";
import ViewEvaluate from "./ViewEvaluate";
import EditEvaluateForm from "./EditEvaluateForm";
import { FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from "../../api/axios";
import { addDays, isAfter, isBefore, isSameDay } from "date-fns";

import Form1PDF from "./Form1PDF";
import Form2PDF from "./Form2PDF";
import Form3PDF, { convertToThaiDate } from "./Form3PDF";
import { ConvertDate } from "../Function/ConvertDate";
import LoadingRound from "../TESTPage/LoadingRound";
import "./animation.scss";
import MyDatePicker from "../../components/Common/MyDateTimePicker";
import LoadingData from "../TESTPage/LoadingData";
import { HistoryEvaluate, SortEvaluate } from "./SortAndHistory";
import MyThaiDatePick from "../../components/Common/ThaiDatePicker";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import { useNavigate } from "react-router-dom";
import NewThaiDatePicker from "../../components/Common/NewThaiDatePicker";
import ConfirmModal from "../../components/Common/ConfirmModal";
import UserSelector from "../../components/users/UsersSelector";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";
import { checkEvaluateScoreLevel, checkEvaluateStaus } from "./evaluateConfig";

const API_URL = process.env.REACT_APP_API_CORS;

function Tabledata(props) {
    const { handleLoad, userInfo, conditon_for_admin = true } = props;
    const token = GetCookieToken("userToken");
    const userData = GetCookieData("userData");
    const user_position = GetCookieData("userPosition");
    const navigate = useNavigate();
    const filterSubAdmin = userData?.positionSubAdmin?.map(i => i?.type_sub_admin);
    const [filterLevel, setFilterLevel] = useState(false);
    const [evaluateData, setEvaluateData] = useState([]);
    const [confrimDate, setConfrimDate] = useState({ start: null, end: null });
    const [loading, setLoading] = useState(false);
    const [dataSelect, setDataSelect] = useState(null);
    const [roundYear, setRoundYear] = useState(null);
    const [roundSelect, setRoundSelect] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataInfo, setDataInfo] = useState([]);
    const [sectionFrom, setSectionFrom] = useState(false);
    const [sectionViewFrom, setSectionViewFrom] = useState(false);
    const [sectionEditFrom, setSectionEditFrom] = useState(false);
    const [evaluateFormID, setEvaluateFormID] = useState(null);
    const [approveEvaluateuserID, setApproveEvaluateuserID] = useState(null);
    const [evaluateSalaryFormID, setEvaluateSalaryFormID] = useState(null);
    const [showDataTable, setShowDataTable] = useState(true);
    const [departmentID, setDepartmentID] = useState(null);
    const [approvUser, setApprovUser] = useState(null);
    const [checkBack, setCheckBack] = useState(null);
    const [status, setStatus] = useState(null);
    const [version, setVersion] = useState(null);
    const [evaluateDataItem, setEvaluateDataItem] = useState(null);
    const [totalPages, setTotalPages] = useState(1);
    const [years, setYears] = useState([]);
    const [currentBudgetYear, setCurrentBudgetYear] = useState(null);
    const [dateStart, setDateStart] = useState(new Date());
    const [dateConfirmStart, setDateConfirmStart] = useState(new Date());
    const [dateConfirmStartlate, setDateConfirmStartlate] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(null);
    const [screeningCommittee, setScreeningCommittee] = useState(null);
    const [dateConfirmEnd, setDateConfirmEnd] = useState(null);
    const [dateConfirmEndlate, setDateConfirmEndlate] = useState(null);
    const [budgetAndRound, setBudgetAndRound] = useState([]);
    const [updateApprove, setUpdateApprove] = useState([]);
    const [currentEndYear, setCurrentEndYear] = useState(new Date("2562-10-1").getFullYear());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [showAccept, setShowAccept] = useState(false);
    const [acceptedSort, setAcceptedSort] = useState(0);
    const [userYear, setUserYear] = useState(null);
    const [userRound, setUserRound] = useState(null);
    const [evaluateSalaryLink, setEvaluateSalaryLink] = useState(null);
    const [checkLoading, setCheckLoading] = useState(false);
    const [confirmModal, setconfirmModal] = useState(false)
    const [sortFilter, setSortFilter] = useState(null)

    useEffect(() => {
        const startYear = currentBudgetYear - 543;
        const endYear = currentEndYear;
        const yearsArray = [];
        for (let year = startYear; year >= endYear; year--) {
            yearsArray.push(year);
        }

        const yearArray = Array.from(
            { length: yearsArray.length },
            (_, index) => currentYear + 543 - index
        );
        setYears(yearArray);

    }, [currentBudgetYear, currentEndYear]);

    const fetchYearEvaluate = async (sort) => {
        const url = `${API_URL}/api/evaluateSalary/datatable`;
        const params = new URLSearchParams({
            page: currentPage,
            size: 1,
            "order[0]": "budget_year",
            "order[1]": sort,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params,
        };
        await axios
            .get(url, config)
            .then((response) => {
                const creatDate = response.data.result.map((i) => i.budget_year);
                if (sort === "DESC") {
                    setCurrentYear(Number(creatDate) - 543);
                } else if (sort === "ASC") {
                    setCurrentEndYear(Number(creatDate) - 543);
                }
            })
            .catch((error) => console.error("Error:", error));
    };

    const fetchFilterBudgetYearEvaluate = async () => {
        const url = `${API_URL}/api/evaluateSalary/datatable`;
        const params = new URLSearchParams({
            page: 1,
            size: 10,
            "order[0]": "evaluate_salary_id",
            "order[1]": "DESC",
            "filter[budget_year][0]": dataSelect ?? currentYear,
            "filter[round][0]": roundSelect ?? roundYear,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params,
        };
        await axios
            .get(url, config)
            .then((response) => {
                setEvaluateData(response.data.result);
                setDataInfo(() => response.data.info);
                setTotalPages(Math.ceil(response.data.info.totalRows / 10));
            })
            .catch((error) => console.error("Error:", error));
    };

    const filterSearch = async () => {
        if (dataSelect !== null || roundSelect !== null) {
            setLoading(true);
            setCurrentPage(1);
            await fetchFilterBudgetYearEvaluate();
            setTimeout(() => {
                setLoading(false);
            }, 1500);
        }
    }


    const [loadingdata, setLoadingdata] = useState(true);

    const fetchEvaluate = async (sort = "DESC", order = "evaluate_salary_id", filtered = undefined, task = "", newSubmenu = true) => {
        setLoadingdata(true)
        const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.get(urlCheckRound, config).then(async (response) => {
            const url = `${API_URL}/api/evaluateSalary/datatable`;
            setRoundYear(response.data.result.this_round);
            setCurrentBudgetYear(response.data.result.this_budget_year);
            let params
            if (conditon_for_admin && CheckSubAdmin(userInfo?.positionSubAdmin)?.length > 0 && (CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(3))) {

                if (filtered === undefined) {
                    params = new URLSearchParams({
                        page: currentPage,
                        size: 10,
                        "order[0]": order,
                        "order[1]": sort,
                        "filter[budget_year][0]": dataSelect ?? response.data.result.this_budget_year,
                        "filter[round][0]": roundSelect ?? response.data.result.this_round,
                    });
                } else {
                    params = new URLSearchParams({
                        page: currentPage,
                        size: 10,
                        "order[0]": order,
                        "order[1]": sort,
                        [`filter[${task}][0]`]: filtered,
                        "filter[budget_year][0]": dataSelect ?? response.data.result.this_budget_year,
                        "filter[round][0]": roundSelect ?? response.data.result.this_round,
                    });
                }
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                };
                await axios
                    .get(url, config)
                    .then((response) => {
                        if (response.data.result.every((i) => i.date_start_confirm)) {
                            const start_date_evaluate = response.data.result.map((i) => i.date_start_confirm);
                            const date_start_add7H = new Date(start_date_evaluate[0]);
                            date_start_add7H.setHours(date_start_add7H.getHours() - 7);
                            setConfrimDate((prev) => ({ ...prev, start: date_start_add7H.toISOString() }));
                        }
                        if (response.data.result.every((i) => i.date_end_confirm)) {
                            const end_date_evaluate = response.data.result.map((i) => i.date_end_confirm);
                            const date_end_add7H = new Date(end_date_evaluate[0]);
                            date_end_add7H.setHours(date_end_add7H.getHours() - 7);
                            setConfrimDate((prev) => ({ ...prev, end: date_end_add7H.toISOString() }));
                        }
                        setEvaluateData(response.data.result);
                        setDataInfo(() => response.data.info);
                        setTotalPages(Math.ceil(response.data.info.totalRows / 10));
                    })
                    .catch((error) => console.error("Error:", error));
            } else {
                if (filtered === undefined) {
                    params = new URLSearchParams({
                        page: currentPage,
                        size: 10,
                        "order[0]": order,
                        "order[1]": sort,
                        "filter[user_id][0]": userData.user_id,
                    });
                } else {
                    params = new URLSearchParams({
                        page: currentPage,
                        size: 10,
                        "order[0]": order,
                        "order[1]": sort,
                        "filter[user_id][0]": userData.user_id,
                        [`filter[${task}][0]`]: filtered,
                        "filter[budget_year][0]": dataSelect ?? response.data.result.this_budget_year,
                        "filter[round][0]": roundSelect ?? response.data.result.this_round,
                    });
                }
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                };
                await axios
                    .get(url, config)
                    .then((response) => {
                        setEvaluateData(response.data.result);
                        setDataInfo(() => response.data.info);
                        setTotalPages(Math.ceil(response.data.info.totalRows / 10));
                    })
                    .catch((error) => console.error("Error:", error));
            }

        });
        setTimeout(() => {
            setLoadingdata(false)
        }, 2000);
    };

    const handleButtonClick = (value) => {
        setSectionFrom(false);
        setShowDataTable(true);
        setLoading(true);
        fetchEvaluate();
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    };

    useEffect(() => {
        if (checkLoading) {
            setLoading(true);
            if (sortFilter) {
                fetchEvaluate(sortFilter?.sort, sortFilter?.event);
            } else {
                fetchEvaluate();
            }
            setTimeout(() => {
                setLoading(false);
            }, 1500);
        }
    }, [currentPage]);

    useEffect(() => {
        fetchEvaluate();
        fecthHistoryDataTable();
        fetchYearEvaluate("DESC");
        fetchYearEvaluate("ASC");
        setCheckLoading(true);
    }, []);

    const handleSwarp = (id, evaluate_salary_id, approve_user_id, user_department_id, year, round, approve_user, version) => {
        setUserYear(year);
        setUserRound(round);
        setEvaluateFormID(id);
        setEvaluateSalaryFormID(evaluate_salary_id);
        setApproveEvaluateuserID(approve_user_id);
        setDepartmentID(user_department_id);
        setApprovUser(approve_user);
        setVersion(version);
    };

    const handleViewSwarp = (
        id,
        evaluate_salary_id,
        approve_user_id,
        user_department_id,
        year,
        round,
        evaluate_url_ref,
        approve_user
    ) => {
        setEvaluateFormID(id);
        setUserYear(year);
        setUserRound(round);
        setEvaluateSalaryFormID(evaluate_salary_id);
        setApproveEvaluateuserID(approve_user_id);
        setEvaluateSalaryLink(evaluate_url_ref);
        // setUpdateApprove(approve_user)
    };

    const handleEditSwarp = (
        id,
        evaluate_salary_id,
        approve_user_id,
        user_department_id,
        status,
        version,
        year,
        round,
        user_name,
        check_sendback
    ) => {
        setUserYear(year);
        setUserRound(round);
        setEvaluateFormID(id);
        setEvaluateSalaryFormID(evaluate_salary_id);
        setApproveEvaluateuserID(approve_user_id);
        setDepartmentID(user_department_id);
        setStatus(status);
        setVersion(version);
        setApprovUser(user_name);
        setCheckBack(check_sendback)
    };

    useEffect(() => {
        RoudAndBud();
    }, []);

    const AddRound = async () => {
        handleLoad("กำลังโหลดข้อมูล");
        try {
            const urlAddRound = "/api/evaluateSalary/addRound";
            const response = await axios.post(
                `${API_URL}${urlAddRound}`,
                {
                    start_date_evaluate: dateStart,
                    end_date_evaluate: dateEnd,
                    screeningCommittee: screeningCommittee?.user_id
                },
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data) {
                RoudAndBud();
            }
            fetchEvaluate();
            fetchYearEvaluate("DESC");
            handleLoad("โหลดเสร็จสิ้น");
        } catch (error) {
            console.error(error);
        }
    };

    const RoudAndBud = () => {
        const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios.get(urlCheckRound, config).then((response) => {
            setBudgetAndRound(response.data.result);
            setScreeningCommittee(response.data.result?.screeningCommittee)
        });
    };

    const handleWitness = (evaluate_salary_id, budget_year, user_id, index) => {
        setLoading(true);
        const currentDate = new Date();
        const dateConvert = ConvertDate(currentDate).toDateISO();
        if (
            userData.user_id !== user_id &&
            userData.user_id !== null &&
            userData.user_id !== undefined
        ) {
            const url = `/api/evaluateSalary/${evaluate_salary_id}`;

            let data = {
                witness_date: dateConvert,
                witness_user: userData.user_name,
                witness_user_id: userData.user_id,
                budget_year: budget_year,
                user_id: user_id,
            };
            FetchAxiosPut(url, data, token);
        }
        fetchEvaluate();
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    };

    const handleAccept = (evaluate_salary_id, budget_year, user_id, index) => {
        setLoading(true);
        const currentDate = new Date();
        const dateConvert = ConvertDate(currentDate).toDateISO();

        if (userData.user_id === user_id) {
            const url = `/api/evaluateSalary/${evaluate_salary_id}`;

            let data = {
                confirm_date: dateConvert,
                confirm_evaluate: 1,
                budget_year: budget_year,
                user_id: user_id,
            };
            FetchAxiosPut(url, data, token);
        }
        fetchEvaluate();
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    };

    const AddConfirm = async () => {
        setLoading(true);
        try {
            const urlAddConfirm = "/api/evaluateSalary/addConfirm";
            let data = {
                date_start_confirm: dateConfirmStart,
                date_end_confirm: dateConfirmEnd,
            };
            await FetchAxiosPost(urlAddConfirm, data, token);
            await fetchEvaluate();
            setTimeout(() => {
                setLoading(false);
            }, 1500);
        } catch (error) {
            console.error(error);
        }
    };

    const AddConfirmlate = async (evaluate_salary_id, user_id, budget_year) => {
        setLoading(true);
        try {
            const urlAddConfirm = `/api/evaluateSalary/${evaluate_salary_id}`;
            let data = {
                date_start_confirm: new Date(dateConfirmStartlate),
                date_end_confirm: new Date(dateConfirmEndlate),
                confirm_evaluate: 0,
                user_id: user_id,
                budget_year: budget_year,
                date_director_confrim: new Date(),
            };
            await FetchAxiosPut(urlAddConfirm, data, token);
            await fetchEvaluate();
            setTimeout(() => {
                setLoading(false);
            }, 1500);
        } catch (error) {
            console.error(error);
        }
    };

    const [date, setDate] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            const newDate = new Date(date.getTime() + 1000);
            setDate(newDate);
        }, 1000);
        return () => clearInterval(interval);
    }, [date]);

    const [open, setOpen] = useState(false);
    const [loadingHistory, setLoadingHistory] = useState(false);
    const [historyEvaluates, setHistoryEvaluates] = useState([])
    const [historyDataTable, setHistoryDataTable] = useState([])
    const [thisEvaluateUserId, setThisEvaluateUserId] = useState()
    const toggleModal = () => {
        setOpen(!open);
    };

    const historyEvaluate = async (id) => {
        setLoadingHistory(true)
        const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.get(urlCheckRound, config).then(response => {
            setBudgetAndRound(response.data.result);
            setScreeningCommittee(response.data.result?.screeningCommittee)
            const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
            const params = new URLSearchParams({
                page: currentPage,
                size: 1000,
                "order[0]": "evaluate_salary_history_id",
                "order[1]": "ASC",
                "filter[evaluate_salary_id][0]": id,
            });
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            };
            axios
                .get(url, config)
                .then(async response => {
                    const result = response.data?.result
                    const lastdata = result[result.length - 1]
                    // await editHistory(lastdata.evaluate_salary_history_id, lastdata.evaluate_salary_id)
                    // const maxVersion = Math.max(
                    //     ...response.data.result.map(x => Number(x.version))
                    // );

                    // const latestVersionArray = response.data.result.filter(
                    //     x => Number(x.version) === maxVersion
                    // );
                    setHistoryEvaluates(() => result);
                })
                .catch((error) => console.error("Error:", error));
        });
        setLoadingHistory(false)
    }

    const editHistory = async (evaluate_salary_history_id, evaluate_salary_id) => {
        const urledit = `/api/evaluateSalaryHistory/${evaluate_salary_history_id}`;
        let data = { status_history: 0, evaluate_salary_id: evaluate_salary_id }
        await FetchAxiosPut(urledit, data, token);
        await fecthHistoryDataTable();
    }

    const fecthHistoryDataTable = async () => {
        const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.get(urlCheckRound, config).then(response => {
            setBudgetAndRound(response.data.result);
            setScreeningCommittee(response.data.result?.screeningCommittee)
            const url = `${API_URL}/api/evaluateSalaryHistory/datatable`;
            const params = new URLSearchParams({
                page: currentPage,
                size: 1000,
                "order[0]": "evaluate_salary_history_id",
                "order[1]": "ASC",
            });
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            };
            axios
                .get(url, config)
                .then(async response => {
                    setHistoryDataTable(response.data.result)
                })
                .catch((error) => console.error("Error:", error));
        });
    }

    const toggleSort = async (event, num) => {
        let sort = ""
        if (showAccept) {
            sort = "ASC"
            fetchEvaluate("ASC", event)
        } else {
            sort = "DESC"
            fetchEvaluate("DESC", event)
        }
        setSortFilter({ sort: sort, event: event })
        setAcceptedSort(num)
    }

    const getDataSort = async (order = "evaluate_salary_id", sort = "DESC", value = undefined, task = "") => {
        if (conditon_for_admin && ((Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3) || filterSubAdmin.includes(0) || filterSubAdmin.includes(3))) {
            if (value === "0") {
                await fetchEvaluate()
            } else {
                await fetchEvaluate(sort, order, value, task)
            }
        }
        else {
            if (value === "0") {
                await fetchEvaluate(userData.user_id);
            } else {
                await fetchEvaluate(userData.user_id, order, sort, value, task);
            }
        }
    }

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (userInfo) {
            if (
                !CheckPosition(userInfo?.position) &&
                !CheckSubAdmin(userInfo?.positionSubAdmin)
            ) {
                navigate("/assessment");
            }
        }
    }, [userInfo]);

    const [Acceptedevaluate_salary_id, setAcceptedevaluate_salary_id] = useState(null)
    const [Accepteduser_id, setAccepteduser_id] = useState(null)
    const [Acceptedbudget_year, setAcceptedbudget_year] = useState(null)
    const [task, setTask] = useState("")
    const [userSort, setUserSort] = useState(false)
    const [userOpition, setUserOpition] = useState([])
    const [filterSection, setFilterSection] = useState(null)
    const confrimModalAscept = async (evaluate_salary_id, user_id, budget_year) => {
        setconfirmModal(true)
        setAcceptedevaluate_salary_id(evaluate_salary_id)
        setAccepteduser_id(user_id)
        setAcceptedbudget_year(budget_year)
    }

    const toggleModalSort = () => {
        setUserSort(!userSort)
    }

    let thisUseerAllEvaluate = async () => {
        const checkRound = (await FetchAxiosGet('/api/evaluateSalary/checkRound', token)).result;
        const params = new URLSearchParams({ page: 1, size: 500, "order[0]": "user_name", "order[1]": "ASC", "filter[budget_year][0]": dataSelect ?? checkRound?.this_budget_year, "filter[round][0]": roundSelect ?? checkRound?.this_round });
        const alluserName = await FetchAxiosGet('/api/evaluateSalary/datatable', token, params);
        let options = [{ value: '0', label: 'ทั้งหมด' }];
        await alluserName?.result?.map(async x => {
            options.push({ value: x.user_id, label: x.user_name })
        })
        options = options.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
                t.value === obj.value
            ));
        });
        setUserOpition(options)
    }

    useEffect(() => {
        thisUseerAllEvaluate()
    }, [])

    useEffect(() => {
        thisUseerAllEvaluate()
    }, [dataSelect, roundSelect])

    return (
        <Fragment>
            <Fragment>
                {loading ? (
                    <LoadingPage />
                ) : showDataTable ? (
                    <FadeIn>
                        <FadeIn>
                            <div className="">
                                <Container fluid>
                                    <Breadcrumb
                                        title="หน้าหลัก"
                                        breadcrumbItem="การประเมินผลการปฏิบัติราชการ"
                                        breadcrumbText={`${(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && conditon_for_admin
                                            && ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3)))
                                            ? "การประเมินผลการปฏิบัติราชการ" : "การประเมินตนเอง"} รอบการประเมินที่ ${budgetAndRound.this_round ?? "..."} ปี ${budgetAndRound.this_budget_year ?? "..."}`}
                                        isBack={false}
                                        isSubMenu={true}
                                        subMenuName={`${(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && conditon_for_admin
                                            && ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3)))
                                            ? "การประเมินผลการปฏิบัติราชการ" : "การประเมินตนเอง"} รอบการประเมินที่ ${budgetAndRound.this_round ?? "..."} ปี ${budgetAndRound.this_budget_year ?? "..."}`}
                                        path="/assessment"
                                    />

                                    {(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && conditon_for_admin
                                        && ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3))) && (
                                            <Row className="d-flex justify-content-center">
                                                <Col md={5}>
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col xs={12} md={12} lg={12} xxl={12}>
                                                                    <h5 style={{ display: "flex", justifyContent: "start" }}>รอบการประเมินถัดไป คือรอบที่ <span className="text-success px-2"> {budgetAndRound.next_round} </span> ปีที่ <span className="text-success ps-2">{budgetAndRound.next_budget_year}</span></h5>
                                                                    <Row className="mb-2 pe-0">
                                                                        <Col style={{ display: "flex", justifyContent: "start", }} xs={12} md={12} lg={12}>
                                                                            {windowSize.width < 576 ?
                                                                                <Col xs={12}>
                                                                                    <UserSelector className={"mb-2"}
                                                                                    // value={{value: x, label: x.approve_user}} onChange={(value) => handleChangeUser(i, value)}
                                                                                    />
                                                                                    <InputGroup className="mb-2">
                                                                                        <InputGroupText>
                                                                                            วันที่เริ่ม
                                                                                        </InputGroupText>
                                                                                        <NewThaiDatePicker rounded="rounded-0" value={dateStart} setValue={setDateStart} placeholderText="วัน/เดือน/ปี" />
                                                                                    </InputGroup>
                                                                                    <InputGroup className="mb-2">
                                                                                        <InputGroupText style={{ borderRadius: "" }}>
                                                                                            วันที่สิ้นสุด
                                                                                        </InputGroupText>
                                                                                        <NewThaiDatePicker rounded="rounded-0" value={dateEnd} minDate={dateStart} setValue={setDateEnd} placeholderText="วัน/เดือน/ปี" />
                                                                                    </InputGroup>
                                                                                    {dateStart !== null &&
                                                                                        dateEnd !== null ? (
                                                                                        <Button
                                                                                            style={{ width: "84px" }}
                                                                                            color="info"
                                                                                            onClick={() => {
                                                                                                setTask("ADDROUND")
                                                                                                setconfirmModal(true)
                                                                                            }}
                                                                                        >
                                                                                            เพิ่มรอบ
                                                                                        </Button>
                                                                                    ) : (
                                                                                        <Button style={{ width: "84px" }} color="info" disabled>
                                                                                            เพิ่มรอบ
                                                                                        </Button>
                                                                                    )}
                                                                                </Col>
                                                                                :
                                                                                <div>
                                                                                    {/* <Label>คณะกรรมการกลั่นกรอง</Label> */}
                                                                                    {/* <UserSelector className={"mb-2"} value={{value: screeningCommittee, label: screeningCommittee?.user_name}} onChange={(value) => setScreeningCommittee(value)} /> */}
                                                                                    <InputGroup className={"mb-2"}>
                                                                                        <InputGroupText style={{ maxHeight: 38 }}>
                                                                                            ผู้ประเมิน
                                                                                        </InputGroupText>
                                                                                        <div style={{ flex: 1 }}>
                                                                                            <UserSelector className={"mb-2"} type={"normal"} value={{ value: screeningCommittee, label: screeningCommittee?.user_name }} onChange={(value) => setScreeningCommittee(value)} />
                                                                                        </div>
                                                                                    </InputGroup>
                                                                                    <InputGroup>
                                                                                        <InputGroupText>
                                                                                            วันที่เริ่ม
                                                                                        </InputGroupText>
                                                                                        <NewThaiDatePicker rounded="rounded-0" value={dateStart} setValue={setDateStart} placeholderText="วัน/เดือน/ปี" />
                                                                                        <InputGroupText>
                                                                                            วันที่สิ้นสุด
                                                                                        </InputGroupText>
                                                                                        <NewThaiDatePicker rounded="rounded-0" value={dateEnd} minDate={dateStart} setValue={setDateEnd} placeholderText="วัน/เดือน/ปี" />
                                                                                        {dateStart !== null &&
                                                                                            dateEnd !== null ? (
                                                                                            <Button
                                                                                                style={{ width: "84px" }}
                                                                                                color="info"
                                                                                                onClick={() => {
                                                                                                    setTask("ADDROUND")
                                                                                                    setconfirmModal(true)
                                                                                                }}
                                                                                            >
                                                                                                เพิ่มรอบ
                                                                                            </Button>
                                                                                        ) : (
                                                                                            <Button style={{ width: "84px" }} color="info" disabled>
                                                                                                เพิ่มรอบ
                                                                                            </Button>
                                                                                        )}
                                                                                    </InputGroup>
                                                                                </div>
                                                                            }

                                                                        </Col>
                                                                    </Row>
                                                                    {confrimDate.start !== null && confrimDate.end !== null &&
                                                                        <h5 style={{ display: "flex", justifyContent: "start" }}>
                                                                            {budgetAndRound?.this_budget_year ? `รอบปัจจุบัน ${budgetAndRound?.this_budget_year}/${budgetAndRound?.this_round} ` : ''}
                                                                            กดรับทราบได้ ตั้งแต่ <span className="text-success px-2"> {ConvertDate(confrimDate.start).toThaiDateDMY()} </span>
                                                                            ถึง <span className="text-success ps-2">{ConvertDate(confrimDate.end).toThaiDateDMY()}</span>
                                                                        </h5>}
                                                                    <Row>
                                                                        <Col style={{ display: "flex", justifyContent: "start" }} lg={12}>
                                                                            {windowSize.width < 576 ?
                                                                                <Col xs={12}>
                                                                                    <InputGroup className="mb-2">
                                                                                        <InputGroupText>
                                                                                            วันที่เริ่ม
                                                                                        </InputGroupText>
                                                                                        {/* <MyThaiDatePick setProbsDate={setDateConfirmStart}/> */}
                                                                                        <NewThaiDatePicker rounded="rounded-0" value={dateConfirmStart} setValue={setDateConfirmStart} placeholderText="วัน/เดือน/ปี" />
                                                                                    </InputGroup>
                                                                                    <InputGroup className="mb-2">
                                                                                        <InputGroupText>
                                                                                            วันที่สิ้นสุด
                                                                                        </InputGroupText>
                                                                                        {/* <MyThaiDatePick setProbsDate={setDateConfirmEnd}/> */}
                                                                                        <NewThaiDatePicker rounded="rounded-0" value={dateConfirmEnd} minDate={dateConfirmStart} placeholderText="วัน/เดือน/ปี" setValue={setDateConfirmEnd} />
                                                                                    </InputGroup>
                                                                                    {dateConfirmStart !== null &&
                                                                                        dateConfirmEnd !== null ? (
                                                                                        <Button
                                                                                            className="z-0"
                                                                                            color="success"
                                                                                            onClick={() => {
                                                                                                setTask("ADDCONFIRM")
                                                                                                setconfirmModal(true)
                                                                                                // const confirmed = window.confirm(
                                                                                                //   "ต้องการที่จะเพิ่มระยะเวลาในการกดรับทราบใช่หรือไม่ "
                                                                                                // );
                                                                                                // if (confirmed) {
                                                                                                //   AddConfirm();
                                                                                                // }
                                                                                            }}
                                                                                        >
                                                                                            กดรับทราบ
                                                                                        </Button>
                                                                                    ) : (
                                                                                        <Button
                                                                                            color="success"
                                                                                            disabled
                                                                                            className="z-0"
                                                                                        >
                                                                                            กดรับทราบ
                                                                                        </Button>
                                                                                    )}
                                                                                </Col>
                                                                                :
                                                                                <InputGroup>
                                                                                    <InputGroupText>
                                                                                        วันที่เริ่ม
                                                                                    </InputGroupText>
                                                                                    {/* <MyThaiDatePick setProbsDate={setDateConfirmStart}/> */}
                                                                                    <NewThaiDatePicker rounded="rounded-0" value={dateConfirmStart} setValue={setDateConfirmStart} placeholderText="วัน/เดือน/ปี" />
                                                                                    <InputGroupText>
                                                                                        วันที่สิ้นสุด
                                                                                    </InputGroupText>
                                                                                    {/* <MyThaiDatePick setProbsDate={setDateConfirmEnd}/> */}
                                                                                    <NewThaiDatePicker rounded="rounded-0" value={dateConfirmEnd} minDate={dateConfirmStart} setValue={setDateConfirmEnd} placeholderText="วัน/เดือน/ปี" />
                                                                                    {dateConfirmStart !== null &&
                                                                                        dateConfirmEnd !== null ? (
                                                                                        <Button
                                                                                            className="z-0"
                                                                                            color="success"
                                                                                            onClick={() => {
                                                                                                setTask("ADDCONFIRM")
                                                                                                setconfirmModal(true)
                                                                                                // const confirmed = window.confirm(
                                                                                                //   "ต้องการที่จะเพิ่มระยะเวลาในการกดรับทราบใช่หรือไม่ "
                                                                                                // );
                                                                                                // if (confirmed) {
                                                                                                //   AddConfirm();
                                                                                                // }
                                                                                            }}
                                                                                        >
                                                                                            กดรับทราบ
                                                                                        </Button>
                                                                                    ) : (
                                                                                        <Button
                                                                                            color="success"
                                                                                            disabled
                                                                                            className="z-0"
                                                                                        >
                                                                                            กดรับทราบ
                                                                                        </Button>
                                                                                    )}
                                                                                </InputGroup>
                                                                            }

                                                                        </Col>
                                                                    </Row>
                                                                    <span className="mt-3 mb-1" style={{ borderBottomStyle: "solid", borderWidth: "1px", width: "100%", display: "inline-block", color: 'gray', opacity: 0.25 }}>{""}</span>
                                                                    <Label>เครื่องมือค้นหา</Label>
                                                                    <Row className="mb-1 z-n1">
                                                                        <Col lg={6}>
                                                                            <InputGroup className={`${(windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992)) && "mb-2"}`}>
                                                                                <InputGroupText>
                                                                                    ปีงบประมาณ :{" "}
                                                                                </InputGroupText>
                                                                                <Input
                                                                                    name="budget_year"
                                                                                    type="select"
                                                                                    placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                                                                                    value={
                                                                                        dataSelect !== null
                                                                                            ? dataSelect
                                                                                            : currentBudgetYear
                                                                                    }
                                                                                    onChange={(e) => setDataSelect(e.target.options[e.target.selectedIndex].text)
                                                                                    }
                                                                                >
                                                                                    {years.map((year) => (
                                                                                        <option key={year} value={year}>
                                                                                            {year}
                                                                                        </option>
                                                                                    ))}
                                                                                </Input>
                                                                            </InputGroup>
                                                                        </Col>
                                                                        <Col lg={6}>
                                                                            <InputGroup>
                                                                                <InputGroupText>รอบ : </InputGroupText>
                                                                                <Input
                                                                                    type="select"
                                                                                    name="round"
                                                                                    value={
                                                                                        roundSelect !== null
                                                                                            ? roundSelect
                                                                                            : roundYear
                                                                                    }
                                                                                    onChange={(e) =>
                                                                                        setRoundSelect(e.target.value)
                                                                                    }
                                                                                    placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                                                                                >
                                                                                    <option value={1}>1</option>
                                                                                    <option value={2}>2</option>
                                                                                </Input>
                                                                            </InputGroup>
                                                                        </Col>
                                                                        <Col className="d-flex justify-content-end mt-2" lg={12}>
                                                                            <Button style={{ width: "100px" }} color="success" onClick={() => { filterSearch(); }}><i className="fa-regular fa-magnifying-glass fa-lg pe-2"></i>ค้นหา</Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )
                                    }

                                    <Table
                                        className="align-middle"
                                        striped
                                        style={{
                                            overflow: "scroll",
                                        }}
                                        responsive
                                    >
                                        <thead className="table-light " style={{ whiteSpace: "nowrap", fontSize: "15px" }}>
                                            <tr>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("budget_year", 0);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    ปี
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 0 ? `fa-duotone ${showAccept ? "fa-sort-down" : "fa-sort-up"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("round", 1);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    รอบ
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 1 ? `fa-duotone ${showAccept ? "fa-sort-up" : "fa-sort-down"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        if (conditon_for_admin && CheckSubAdmin(userInfo?.positionSubAdmin) && (CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(3))) {
                                                            toggleModalSort();
                                                            setFilterSection(0);
                                                            setCurrentPage(1);
                                                        } else {
                                                            toggleSort("user_name", 2);
                                                            setShowAccept(() => !showAccept)
                                                        }
                                                    }
                                                    }
                                                >
                                                    ผู้รับการประเมิน
                                                    {
                                                        <i className={
                                                            `ps-2 text-secondary 
                                                            ${CheckSubAdmin(userInfo?.positionSubAdmin) && conditon_for_admin &&
                                                                (CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(0)
                                                                    || CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(3))
                                                                ?
                                                                "ps-1 fa-solid fa-magnifying-glass"
                                                                : acceptedSort === 2 ?
                                                                    `fa-duotone ${showAccept ? "fa-sort-up"
                                                                        : "fa-sort-down"}`
                                                                    : "fa-regular fa-sort opacity-50"
                                                            }
                                                        `}>
                                                        </i>
                                                    }
                                                    {
                                                        CheckSubAdmin(userInfo?.positionSubAdmin) && conditon_for_admin &&
                                                        (CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(0)
                                                            || CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(3)) &&
                                                        <div className="mt-1 fs-6 text-danger"> *สามารถค้นหารายชื่อได้* </div>
                                                    }
                                                </th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("confirm_date", 3);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    {/* วันที่ส่งแบบประเมิน */}
                                                    วันที่กดรับทราบ
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 3 ? `fa-duotone ${showAccept ? "fa-sort-up" : "fa-sort-down"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("show_score", 4);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    คะแนน
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 4 ? `fa-duotone ${showAccept ? "fa-sort-up" : "fa-sort-down"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("show_score", 5);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    การประเมิน
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 5 ? `fa-duotone ${showAccept ? "fa-sort-up" : "fa-sort-down"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("status", 6);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    สถานะ
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 6 ? `fa-duotone ${showAccept ? "fa-sort-up" : "fa-sort-down"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                {/* <th
                                                  className="text-center"
                                                  style={{
                                                    verticalAlign: "middle",
                                                    // whiteSpace: "nowrap",
                                                    // cursor: "pointer",
                                                    // transition: "background-color 0.3s",
                                                  }}
                                                >
                                                  <Row className="text-center">
                                                    <Col lg={3} className="me-1">สถานะ</Col>
                                                    <Col lg={3}>
                                                      <Dropdown isOpen={filterLevel} toggle={() => filterLevelStatus()}>
                                                        <DropdownToggle className="p-0 btn btn-outline-dark" caret color="light">
                                                          <i className="mdi mdi-chevron-down" />
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                          {dropdown.map((i, idx)=>{
                                                            return(
                                                            <Fragment key={idx}>
                                                              <DropdownItem value={i.values} onClick={(e)=> getDataSort(undefined, undefined, e.target.value, "status")}>{i.label}</DropdownItem>
                                                            </Fragment>
                                                            )
                                                          })}
                                                        </DropdownMenu>
                                                      </Dropdown>
                                                    </Col>
                                                  </Row>
                                                </th> */}
                                                <th className="text-center" style={{ verticalAlign: "middle", whiteSpace: "nowrap", cursor: "pointer", transition: "background-color 0.3s" }}>ประเมินตนเอง</th>
                                                <th className="text-center"
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(215,218,222,0.6)"}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(239,242,247,1)"}
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                    }}
                                                    onClick={() => {
                                                        toggleSort("version", 7);
                                                        setShowAccept(() => !showAccept)
                                                    }
                                                    }
                                                >
                                                    เวอร์ชัน
                                                    {<i className={`ps-2 text-secondary ${acceptedSort === 7 ? `fa-duotone ${showAccept ? "fa-sort-up" : "fa-sort-down"}` : "fa-regular fa-sort opacity-50"}`}></i>}
                                                </th>
                                                <th className="text-center align-middle">
                                                    ผลการประเมิน
                                                    <br />
                                                    ผู้บังคับบัญชา
                                                </th>
                                                <th className="text-center"
                                                    style={{
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                        cursor: "pointer",
                                                        transition: "background-color 0.3s",
                                                        width: "150px"
                                                    }}
                                                >
                                                    ผลการ
                                                    <br />
                                                    ประเมิน
                                                    <br />
                                                    สุดท้าย
                                                </th>
                                                <th style={{ width: "150px" }}></th>
                                            </tr>
                                        </thead>

                                        {loadingdata ?
                                            <tbody className="border boder-dark text-center">
                                                <tr>
                                                    <td colSpan="12" className="text-center fs-5">
                                                        <LoadingData />
                                                    </td>
                                                </tr>
                                            </tbody>
                                            :
                                            <tbody className="text-center" style={{ whiteSpace: "nowrap", fontSize: "15px" }}>
                                                {evaluateData.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="12" className="text-center fs-5">
                                                            ไม่มีข้อมูล
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    evaluateData.map((i, index) => {
                                                        const priorityPositions = [5, 7, 3, 4, 2]; //check ผอ.กอง > ผอ.กลุ่ม > รอง > เลขา
                                                        let checkpointApproved = false
                                                        let flow = i.evaluateSalaryFlow.filter(x => x.status === 1)
                                                        let thisApprove = i.evaluateSalaryApprove
                                                        const maxVersion = Math.max(
                                                            ...thisApprove.map(item => Number(item.version) || 0)
                                                        );
                                                        thisApprove = thisApprove.filter(
                                                            item => Number(item.version) === maxVersion
                                                        );

                                                        let thisApproveCheckPoint = null
                                                        let thisApproveCheckPointUncheckApprove = null
                                                        if (flow.length > 0 && thisApprove.length > 0) {
                                                            let userCheckPoint = priorityPositions
                                                                .map(pid =>
                                                                    flow.find(x => {
                                                                        const pos = x.userApproveDataPosition;

                                                                        // กรณีเป็น array
                                                                        if (Array.isArray(pos)) {
                                                                            return pos.some(p => p.position_id === pid && p.assign !== 1);
                                                                        }

                                                                        // กรณีเป็น object
                                                                        return pos?.position_id === pid;
                                                                    })
                                                                )
                                                                .find(Boolean);
                                                            thisApproveCheckPointUncheckApprove = userCheckPoint                                                            

                                                            thisApproveCheckPoint = thisApprove.filter(x => x.approve_user_id === userCheckPoint?.approve_user_id).find(x => x?.approve_status === "1")

                                                            if (thisApprove.length > 0 && userCheckPoint) {
                                                                let userCheckPointApproved = thisApproveCheckPoint ? true : false
                                                                checkpointApproved = userCheckPointApproved
                                                            }
                                                        }

                                                        return (
                                                            <tr key={index}>
                                                                <td>{i.budget_year}</td>
                                                                <td>{i.round}</td>
                                                                <td>{i.user_name}</td>
                                                                <td>
                                                                    {i.confirm_date === null
                                                                        ? ""
                                                                        : 
                                                                        // dayjs.utc(i.confirm_date).format("DD/MM/YYYY")
                                                                        convertToThaiDate(i.confirm_date)
                                                                            }
                                                                </td>
                                                                <td>
                                                                    {i.show_score === null || i.show_score === undefined
                                                                        ? "0.00"
                                                                        : Number(i.show_score).toFixed(2)}
                                                                </td>
                                                                <td>
                                                                    {checkEvaluateScoreLevel(i.show_score)}
                                                                </td>
                                                                <td>
                                                                    {checkEvaluateStaus(i.status)}
                                                                </td>
                                                                <td style={{ width: "130px" }}>
                                                                    <Row className="mb-2 ">
                                                                        {i.status === "2" ||
                                                                            i.status === "3" ||
                                                                            i.status === "5" ||
                                                                            i.status === "9" ||
                                                                            (i.status === "4" &&
                                                                                i.check_sendback !== "1") ? (
                                                                            <Fragment>
                                                                                <Button
                                                                                    className="mb-1"
                                                                                    color="info"
                                                                                    onClick={() => {
                                                                                        // fetchEvaluateApprove(i.user_id, i.budget_year, i.round)
                                                                                        handleViewSwarp(
                                                                                            i.user_id,
                                                                                            i.evaluate_salary_id,
                                                                                            i.approve_user_id,
                                                                                            i.user_department_id,
                                                                                            i.budget_year,
                                                                                            i.round,
                                                                                            i.evaluate_url_ref,
                                                                                            // i.approve_user
                                                                                        );
                                                                                        setSectionViewFrom(true);
                                                                                        setShowDataTable(false);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa-solid fa-magnifying-glass me-2"></i>
                                                                                    ดูข้อมูล
                                                                                </Button>

                                                                                <Form1PDF
                                                                                    open={1}
                                                                                    task={1}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    approveId={i.approve_user_id}
                                                                                    userDepartment={i.user_department}
                                                                                    version={i.version}
                                                                                    checkSingnum={false}
                                                                                    evaluateDataItem={i}
                                                                                    approveCheckPointUser={thisApproveCheckPointUncheckApprove}
                                                                                />
                                                                                <Form2PDF
                                                                                    open={1}
                                                                                    task={1}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    approveId={i.approve_user_id}
                                                                                    userDepartment={i.user_department}
                                                                                    version={i.version}
                                                                                    checkSingnum={false}
                                                                                    evaluateDataItem={i}
                                                                                    approveCheckPointUser={thisApproveCheckPointUncheckApprove}
                                                                                />
                                                                            </Fragment>
                                                                        ) : i.status === "0" ? (
                                                                            <Button
                                                                                color="success"
                                                                                className="mb-1"
                                                                                onClick={() => {
                                                                                    handleSwarp(
                                                                                        i.user_id,
                                                                                        i.evaluate_salary_id,
                                                                                        i.approve_user_id,
                                                                                        i.user_department_id,
                                                                                        i.budget_year,
                                                                                        i.round,
                                                                                        i.user_name,
                                                                                        i.version
                                                                                    );
                                                                                    setSectionFrom(true);
                                                                                    setShowDataTable(false);
                                                                                }}
                                                                            >
                                                                                <i className="fa-sharp fa-solid fa-pen-nib me-2"></i>
                                                                                กรอกข้อมูล
                                                                            </Button>
                                                                        ) : i.status === "1" ||
                                                                            (i.status === "4" &&
                                                                                i.check_sendback === "1") ? (
                                                                            <Button
                                                                                color="warning"
                                                                                onClick={() => {
                                                                                    handleEditSwarp(
                                                                                        i.user_id,
                                                                                        i.evaluate_salary_id,
                                                                                        i.approve_user_id,
                                                                                        i.user_department_id,
                                                                                        i.status,
                                                                                        i.version,
                                                                                        i.budget_year,
                                                                                        i.round,
                                                                                        i.approve_user,
                                                                                        i.check_sendback
                                                                                    );
                                                                                    setSectionEditFrom(true);
                                                                                    setShowDataTable(false);
                                                                                }}
                                                                            >
                                                                                <i className="fa-solid fa-pen-to-square me-2"></i>
                                                                                แก้ไข
                                                                            </Button>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </Row>
                                                                </td>
                                                                <td className="text-center">{i.version}</td>
                                                                <td>
                                                                    {(checkpointApproved && i.status !== "4") ? (
                                                                        <>
                                                                            <Row>
                                                                                <Form1PDF
                                                                                    open={1}
                                                                                    task={2}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    approveId={i.approve_user_id}
                                                                                    userDepartment={i.user_department}
                                                                                    version={i.version}
                                                                                    confirmSignnum={i.confirm_signnum}
                                                                                    updateApprove={updateApprove[0]}
                                                                                    evaluateDataItem={i}
                                                                                    approveCheckPointUser={thisApproveCheckPoint}
                                                                                    checkPointApproved={true}
                                                                                />
                                                                            </Row>
                                                                            <Row>
                                                                                <Form2PDF
                                                                                    open={1}
                                                                                    task={2}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    updateApprove={updateApprove[0]}
                                                                                    approveId={i.approve_user_id}
                                                                                    userDepartment={i.user_department}
                                                                                    version={i.version}
                                                                                    confirmSignnum={i.confirm_signnum}
                                                                                    evaluateDataItem={i}
                                                                                    approveCheckPointUser={thisApproveCheckPoint}
                                                                                    checkPointApproved={true}
                                                                                />
                                                                            </Row>
                                                                            <Row>
                                                                                {
                                                                                    // user_position.find(x => x.org_id === 39 && x.position_id === 7) ? (
                                                                                    // <Button
                                                                                    //     color="warning"
                                                                                    //     onClick={() => handleWitness(
                                                                                    //             i.evaluate_salary_id,
                                                                                    //             i.budget_year,
                                                                                    //             i.user_id,
                                                                                    //             index
                                                                                    //         )}>พยาน
                                                                                    // </Button>) :
                                                                                    ((i.confirm_evaluate && i.confirm_evaluate === "1") ?
                                                                                        <Form3PDF
                                                                                            open={1}
                                                                                            task={2}
                                                                                            budgetYear={i.budget_year}
                                                                                            round={i.round}
                                                                                            evaluateSalaryID={
                                                                                                i.evaluate_salary_id
                                                                                            }
                                                                                            userID={i.user_id}
                                                                                            userName={i.user_name}
                                                                                            witnessUserID={i.witness_user_id}
                                                                                            witnessDate={i.witness_date}
                                                                                            witnessSignnum={i.witness_signnum}
                                                                                            witnessUser={i.witness_user}
                                                                                            confirmDate={i.confirm_date}
                                                                                            approveId={i.approve_user_id}
                                                                                            updateApprove={updateApprove[0]}
                                                                                            userDepartment={i.user_department}
                                                                                            version={i.version}
                                                                                            showLeka={false}
                                                                                            evaluateDataItem={i}
                                                                                            approveCheckPointUser={thisApproveCheckPoint}
                                                                                            checkPointApproved={true}
                                                                                        /> : <Button
                                                                                            disabled={
                                                                                                i.user_id !== userInfo.user_id
                                                                                                //  (userData.positionSubAdmin
                                                                                                //     .length !== 0 && conditon_for_admin &&
                                                                                                //   userData.positionSubAdmin.find(
                                                                                                //     (i) =>
                                                                                                //       i.type_sub_admin === 0 ||
                                                                                                //       i.type_sub_admin === 3
                                                                                                //   ))
                                                                                            }
                                                                                            style={{ backgroundColor: '#417DFE', borderColor: '#417DFE' }}
                                                                                            onClick={() =>
                                                                                                handleAccept(
                                                                                                    i.evaluate_salary_id,
                                                                                                    i.budget_year,
                                                                                                    i.user_id,
                                                                                                    index
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            รับทราบ
                                                                                        </Button>)
                                                                                }
                                                                            </Row>
                                                                        </>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {i.status === "3" || i.status === "5" ? (
                                                                        <div className="mx-2">
                                                                            <Row>
                                                                                <Form1PDF
                                                                                    open={1}
                                                                                    task={3}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    updateApprove={updateApprove[0]}
                                                                                    approveId={i.approve_user_id}
                                                                                    userDepartment={i.user_department}
                                                                                    evaluateDataItem={i}
                                                                                    version={i.version}
                                                                                    confirmSignnum={i.confirm_signnum}
                                                                                    lastStepApproved={true}
                                                                                />
                                                                            </Row>
                                                                            <Row>
                                                                                <Form2PDF
                                                                                    open={1}
                                                                                    task={3}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    updateApprove={updateApprove[0]}
                                                                                    approveId={i.approve_user_id}
                                                                                    userDepartment={i.user_department}
                                                                                    evaluateDataItem={i}
                                                                                    version={i.version}
                                                                                    confirmSignnum={i.confirm_signnum}
                                                                                    lastStepApproved={true}
                                                                                />
                                                                            </Row>
                                                                            <Row>
                                                                                <Form3PDF
                                                                                    open={1}
                                                                                    task={3}
                                                                                    budgetYear={i.budget_year}
                                                                                    round={i.round}
                                                                                    evaluateSalaryID={
                                                                                        i.evaluate_salary_id
                                                                                    }
                                                                                    userID={i.user_id}
                                                                                    userName={i.user_name}
                                                                                    witnessUserID={i.witness_user_id}
                                                                                    confirmDate={i.confirm_date}
                                                                                    approveId={i.approve_user_id}
                                                                                    updateApprove={updateApprove[0]}
                                                                                    userDepartment={i.user_department}
                                                                                    version={i.version}
                                                                                    evaluateDataItem={i}
                                                                                    approveCheckPointUser={thisApproveCheckPoint}
                                                                                    lastStepApproved={true}
                                                                                />
                                                                            </Row>
                                                                        </div>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <Button className="mt-1 position-relative beat-container"
                                                                        onClick={async () => {
                                                                            toggleModal();
                                                                            setEvaluateDataItem(i)
                                                                            setThisEvaluateUserId(i.user_id)
                                                                            await historyEvaluate(i.evaluate_salary_id);
                                                                        }}
                                                                        color="warning">
                                                                        <i className="fa-sharp fa-solid fa-bullseye-pointer me-2"></i> ประวัติคะแนน
                                                                        {historyDataTable?.length > 0 &&
                                                                            Number((historyDataTable.filter(itemBox => Number(itemBox?.evaluate_salary_id) === i.evaluate_salary_id)
                                                                            [historyDataTable.filter(itemBox => Number(itemBox?.evaluate_salary_id) === i.evaluate_salary_id).length - 1]?.status_history)) === 1
                                                                            ? (
                                                                                <div className="translate-middle position-absolute top-0 start-100">
                                                                                    <Badge color="danger" pill className="beat">
                                                                                        ใหม่
                                                                                    </Badge>
                                                                                </div>
                                                                            ) : ""}
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                            // :""
                                                        );
                                                    })
                                                )}
                                            </tbody>}
                                    </Table>
                                    <Row>
                                        <Col className="d-flex justify-content-center justify-content-sm-end">
                                            <Pagination className="mt-3">
                                                <PaginationItem disabled={currentPage === 1}>
                                                    <PaginationLink onClick={() => setCurrentPage(1)}>
                                                        หน้าแรก
                                                    </PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem disabled={currentPage === 1}>
                                                    <PaginationLink
                                                        onClick={() => setCurrentPage(currentPage - 1)}
                                                    >
                                                        ย้อนกลับ
                                                    </PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem active>
                                                    <PaginationLink>หน้า {currentPage}</PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem
                                                    disabled={
                                                        currentPage === dataInfo.totalPage ||
                                                        totalPages === 0
                                                    }
                                                >
                                                    <PaginationLink
                                                        onClick={() =>
                                                            setCurrentPage(dataInfo.currentPage + 1)
                                                        }
                                                    >
                                                        ถัดไป
                                                    </PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem
                                                    disabled={
                                                        currentPage === totalPages || totalPages === 0
                                                    }
                                                >
                                                    <PaginationLink
                                                        onClick={() => setCurrentPage(dataInfo.totalPage)}
                                                    >
                                                        หน้าสุดท้าย
                                                    </PaginationLink>
                                                </PaginationItem>
                                            </Pagination>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </FadeIn>
                    </FadeIn>
                ) : loading ? (
                    <LoadingPage />
                ) : sectionFrom === true ? (
                    <FadeIn>
                        <EvaluateForm
                            onButtonClick={handleButtonClick}
                            user_id={evaluateFormID}
                            approve_user_id={approveEvaluateuserID}
                            evaluate_salary_id={evaluateSalaryFormID}
                            budget_year={userYear}
                            version={version}
                            round={userRound}
                            user_department_id={departmentID}
                            approve_user={approvUser}
                        />

                        <Button
                            className="mb-3 mt-0"
                            color="info"
                            onClick={() => {
                                setSectionFrom(false);
                                setShowDataTable(true);
                                handleButtonClick()
                            }}
                        >
                            กลับไปหน้าแรก
                        </Button>
                    </FadeIn>
                ) : sectionViewFrom === true ? (
                    <FadeIn>
                        <ViewEvaluate
                            onButtonClick={handleButtonClick}
                            user_id={evaluateFormID}
                            approve_user_id={approveEvaluateuserID}
                            evaluate_salary_id={evaluateSalaryFormID}
                            budget_year={userYear}
                            round={userRound}
                            version={version}
                            // updateApprove={updateApprove}
                            updateApprove={updateApprove[0]}
                            approve_user={approvUser}
                            evaluateLink={evaluateSalaryLink}
                            userInfo={userInfo}
                        />

                        <Button
                            className="mb-3 mt-0"
                            color="info"
                            onClick={() => {
                                setSectionViewFrom(false);
                                setShowDataTable(true);
                                handleButtonClick()
                            }}
                        >
                            กลับไปหน้าแรก
                        </Button>
                    </FadeIn>
                ) : sectionEditFrom === true ? (
                    <FadeIn>
                        <EditEvaluateForm
                            onButtonClick={handleButtonClick}
                            user_id={evaluateFormID}
                            approve_user_id={
                                approveEvaluateuserID === null
                                    ? evaluateFormID
                                    : approveEvaluateuserID
                            }
                            evaluate_salary_id={evaluateSalaryFormID}
                            budget_year={userYear}
                            round={userRound}
                            user_department_id={departmentID}
                            status={status}
                            version={version}
                            approve_user={approvUser}
                            useridmyself={evaluateFormID}
                            checkBack={checkBack}
                        />

                        <Button
                            className="mb-3 mt-0"
                            color="info"
                            onClick={() => {
                                setSectionEditFrom(false);
                                setShowDataTable(true);
                                handleButtonClick()
                            }}
                        >
                            กลับไปหน้าแรก
                        </Button>
                    </FadeIn>
                ) : (
                    ""
                )}
                <HistoryEvaluate open={open} toggle={toggleModal} data={historyEvaluates} thisEvaluateUserId={thisEvaluateUserId} evaluateData={evaluateDataItem} loading={loadingHistory}/>
                {filterSection === 0 && <SortEvaluate openSort={userSort} toggleSort={toggleModalSort} data={userOpition} getData={getDataSort} prefixAndPlachoder={"เจ้าหน้าที่"} headers={"เจ้าหน้าที่"} task={"user_id"} />}
                <ConfirmModal
                    modal={confirmModal}
                    modalSize="md"
                    modalHeaderContent={
                        task === "ADDCONFIRMLATE" ? "ต้องการที่จะเพิ่มระยะเวลาในการกดรับทราบใช่หรือไม่"
                            :
                            task === "ADDCONFIRM" ? "ต้องการที่จะเพิ่มระยะเวลาในการกดรับทราบใช่หรือไม่"
                                :
                                task === "ADDROUND" ? "ต้องการที่จะเพิ่มรอบการประเมินใช่หรือไม่"
                                    : ""
                    }
                    onClickConfirmBtn={() => {
                        // handleSubmit();
                        if (task === "ADDCONFIRMLATE") {
                            AddConfirmlate(Acceptedevaluate_salary_id, Accepteduser_id, Acceptedbudget_year)
                        } else if (task === "ADDCONFIRM") {
                            AddConfirm();
                        } else if (task === "ADDROUND") {
                            AddRound();
                        }
                        setconfirmModal(false)
                    }}
                    onClickCancelBtn={() => {
                        setconfirmModal(false)
                    }}
                />
            </Fragment>
        </Fragment>
    );
}

export default Tabledata;

// ) : (
//     ""
// )}
// {i.confirm_evaluate === "1" && user_position.find(x => x.org_id === 39 && x.position_id === 7) ? (
//     <Button
//         color="warning"
//         onClick={() =>
//             handleWitness(
//                 i.evaluate_salary_id,
//                 i.budget_year,
//                 i.user_id,
//                 index
//             )
//         }
//     >
//         พยาน
//     </Button>
// ) : (checkRubSarb && i.user_id === userInfo.user_id && i.date_end_confirm !== null && i.date_start_confirm !== null)
//     || (checkRubSarb && i.date_director_confrim !== null)
//     ? (
//         (isAfter(new Date(date), new Date(i.date_start_confirm?.slice(0, -1))) && isBefore(new Date(date), new Date(i.date_end_confirm.slice(0, -1))))
//             || isSameDay(new Date(), new Date(i.date_start_confirm?.slice(0, -1)))
//             ? (
//                 i.confirm_date === null ? (
//                     <Button
//                         disabled={
//                             i.user_id !== userInfo.user_id
//                             //  (userData.positionSubAdmin
//                             //     .length !== 0 && conditon_for_admin &&
//                             //   userData.positionSubAdmin.find(
//                             //     (i) =>
//                             //       i.type_sub_admin === 0 ||
//                             //       i.type_sub_admin === 3
//                             //   ))
//                         }
//                         // color="success"
//                         style={{ backgroundColor: '#417DFE' }}
//                         onClick={() =>
//                             handleAccept(
//                                 i.evaluate_salary_id,
//                                 i.budget_year,
//                                 i.user_id,
//                                 index
//                             )
//                         }
//                     >
//                         รับทราบ
//                     </Button>
//                 ) : (
//                     ""
//                 )
//             ) : userData.positionSubAdmin.length !== 0 && conditon_for_admin &&
//                 userData.positionSubAdmin.find((i) => i.type_sub_admin === 0 || i.type_sub_admin === 3) &&
//                 isAfter(new Date(i.date_end_confirm), new Date(date)) &&
//                 i.confirm_date === null &&
//                 i.date_director_confrim === null &&
//                 (i.date_end_confirm !== null ||
//                     i.date_start_confirm !== null) ? (
//                 <Fragment>
//                     <InputGroup className="px-0 mb-1">
//                         {/* <InputGroupText className="w-100">
//                           วันที่เริ่ม
//                         </InputGroupText> */}
//                         <Label className="fs-6">วันที่เริ่ม</Label>
//                         {/* <MyThaiDatePick setProbsDate={setDateConfirmStartlate}/> */}
//                         <NewThaiDatePicker value={dateConfirmStartlate} placeholderText="วัน/เดือน/ปี" setValue={setDateConfirmStartlate} />
//                     </InputGroup>
//                     <InputGroup className="px-0 mb-1">
//                         <Label className="fs-6">วันที่สิ้นสุด</Label>
//                         {/* <MyThaiDatePick setProbsDate={setDateConfirmEndlate}/> */}
//                         <NewThaiDatePicker value={dateConfirmEndlate} minDate={dateConfirmStartlate} placeholderText="วัน/เดือน/ปี" setValue={setDateConfirmEndlate} />
//                     </InputGroup>
//                     {dateConfirmStartlate !== null &&
//                         dateConfirmEndlate !== null ? (
//                         <Button
//                             color="warning"
//                             onClick={() => {
//                                 confrimModalAscept(i.evaluate_salary_id, i.user_id, i.budget_year)
//                                 setTask("ADDCONFIRMLATE")
//                             }}
//                         >
//                             ตั้งเวลาการกดรับทราบ
//                         </Button>
//                     ) : (
//                         <Button color="warning" disabled>
//                             ตั้งเวลาการกดรับทราบ
//                         </Button>
//                     )}
//                 </Fragment>
//             ) : userData.positionSubAdmin.length !== 0 && conditon_for_admin &&
//                 userData.positionSubAdmin.find(
//                     (i) =>
//                         i.type_sub_admin === 0 ||
//                         i.type_sub_admin === 3
//                 ) &&
//                 isBefore(
//                     new Date(i.date_end_confirm),
//                     new Date(date)
//                 ) &&
//                 i.confirm_date === null &&
//                 i.witness_date === null &&
//                 (i.date_end_confirm !== null ||
//                     i.date_start_confirm !== null) && user_position.find(x => x.org_id === 39 && x.position_id === 7) ? (
//                 <Button
//                     color="warning"
//                     onClick={() =>
//                         handleWitness(
//                             i.evaluate_salary_id,
//                             i.budget_year,
//                             i.user_id,
//                             index
//                         )
//                     }
//                 >
//                     พยาน
//                 </Button>
//             ) : (
//                 ""
//             )
//     ) : (
//         ""
//     )}
